import { render, staticRenderFns } from "./SupplierTariffDisplay.vue?vue&type=template&id=78bf2c96"
import script from "./SupplierTariffDisplay.vue?vue&type=script&lang=js"
export * from "./SupplierTariffDisplay.vue?vue&type=script&lang=js"
import style0 from "./SupplierTariffDisplay.vue?vue&type=style&index=0&id=78bf2c96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports